import { createTheme } from "@mui/material";




const appTheme = createTheme({
  palette: {
    primary: {
      main: "#08253c"
    },
    secondary: {
        main: "#f44336", //TODO: Move ccolor to color.ts and import from there. 
        light: "#efefef"
    },
    text: {
      primary: "#474747",
      secondary: "#095e9f"
    },
  },
});

export default appTheme;
